/** Path prefix supported after the domain: /ru, /en, /tj */
export const LOCALE_PATH_CODES = ["ru", "en", "tj"];

const SEGMENTS = new Set(LOCALE_PATH_CODES);

export function localeFromPathname(pathname) {
  const first = pathname.replace(/^\/+|\/+$/g, "").split("/")[0];
  if (!first) return null;
  const code = first.toLowerCase();
  return SEGMENTS.has(code) ? code : null;
}

export function normalizePathLocale(code) {
  if (!code) return "ru";
  const base = String(code).split("-")[0].toLowerCase();
  return SEGMENTS.has(base) ? base : "ru";
}

/** Updates URL to /{locale} preserving query and hash (no extra history entry). */
export function replaceLocalePath(code) {
  const seg = normalizePathLocale(code);
  const next = `/${seg}${window.location.search}${window.location.hash}`;
  window.history.replaceState(null, "", next);
}
